<template>
  <div
    class="dropdown"
    @click="toggleRiskLevels"
    :class="{ expanded: isExpanded }"
    :style="computedStyles"
  >
    <div class="dropdown-label-container">
      <div class="dropdown-label">
        <img v-if="config.placeholder == '繁體中文'" :src="configOptions[0].img" width="20px" height="20px">
        <img v-if="config.placeholder == 'English'" :src="configOptions[1].img" width="20px" height="20px">
        <img v-if="config.placeholder == '日本語'" :src="configOptions[2].img" width="20px" height="20px">
        <img v-if="config.placeholder == 'Deutsch'" :src="configOptions[3].img" width="20px" height="20px">
        <img v-if="config.placeholder == 'Français'" :src="configOptions[4].img" width="20px" height="20px">
        <img v-if="config.placeholder == 'ไทย'" :src="configOptions[5].img" width="20px" height="20px">
        
        

        <span class="text">
          {{ (config.prefix ? config.prefix : "") + " "
          }}{{ config.placeholder ? config.placeholder : "" }}
        </span>
        <i class="angle-down" :class="{ toggled: isExpanded }"></i>
      </div>
    </div>

    <div v-expand="isExpanded" class="options expand">
      <div
        v-for="option in configOptions"
        class="option"
        @click="setCurrentSelectedOption(option);"
      > <img v-bind:src="option.img" width="20px"/>  
        {{ option.value }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "dropdown",
  data() {
    return {
      isBottomSectionToggled: true,
      optionsHeight: 0,
      optionHeight: 35,
      width: 100,
      configOptions: [],
      backgroundColor: "#cde4f5",
      backgroundExpandedColor: "#fff",
      hoverBackgroundColor: "#0084d4",
      border: "1px solid  #232b35",
      borderRadius: 0,
      textColor: "#fff",
      isExpanded: false
    };
  },
  components: {},
  props: ["config"],
  computed: {
    computedStyles: function() {
      return [
        { "--options-height": this.optionsHeight + "px" },
        { "--options-height-neg": "-" + this.optionsHeight + "px" },
        { "--option-height": this.optionHeight + "px" },
        { "--main-el-border-radius": this.borderRadius },
        { "--dropdown-width": this.width + "px" },
        { "--dropdown-background-color": this.backgroundColor },
        { "--dropdown-expanded-color": this.backgroundExpandedColor },
        { "--dropdown-border": this.border },
        { "--dropdown-hover-background-color": this.hoverBackgroundColor },
        { "--dropdown-default-text-color": this.textColor }
      ];
    }
  },
  directives: {
    expand: {
      inserted: function(el, binding) {
        if (binding.value !== null) {
          function calcHeight() {
            const currentState = el.getAttribute("aria-expanded");
            el.classList.add("u-no-transition");
            el.removeAttribute("aria-expanded");
            el.style.height = null;
            el.style.height = el.clientHeight + "px";
            el.setAttribute("aria-expanded", currentState);

            setTimeout(function() {
              el.classList.remove("u-no-transition");
            });
          }
          el.classList.add("expand");
          el.setAttribute("aria-expanded", binding.value ? "true" : "false");
          calcHeight();
          window.addEventListener("resize", calcHeight);
        }
      },
      update: function(el, binding) {
        if (el.style.height && binding.value !== null) {
          el.setAttribute("aria-expanded", binding.value ? "true" : "false");
        }
      }
    }
  },
  methods: {
    toggleRiskLevels() {
      this.isExpanded = !this.isExpanded;
    },
    setCurrentSelectedOption(option) {
      this.$emit("setSelectedOption", option);
    },
    setConfigData() {
      this.configOptions = this.config.options;
      this.width = this.config.width;
      this.placeholder = this.config.placeholder;
      if (this.config.backgroundColor) {
        this.backgroundColor = this.config.backgroundColor;
      }
      if (this.config.backgroundExpandedColor) {
        this.backgroundExpandedColor = this.config.backgroundExpandedColor;
      }
      if (this.config.border) {
        this.border = this.config.border;
      }
      if (this.config.hoverBackgroundColor) {
        this.hoverBackgroundColor = this.config.hoverBackgroundColor;
      }
      if (this.config.textColor) {
        this.textColor = this.config.textColor;
      }
      if (this.config.borderRadius) {
        this.borderRadius = this.config.borderRadius;
      }
    },
    setOptionsHeight() {
      this.optionsHeight = this.optionHeight * this.configOptions.length;
    }
  },
  created() {
    this.setConfigData();
    this.setOptionsHeight();
  },
  beforeUdate() {
    // this.setOptionsHeight();
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
@import "./vue-dropdown";
</style>



// WEBPACK FOOTER //
// src/components/vue-dropdown/vue-dropdown.vue